import i18n from 'i18next';
import { getIntegrationErrorMessage } from '@/lib/integration-error-message.js';

/** Matches API `ticket-terminal-guard` response `code`. */
export const TICKET_API_READ_ONLY_CODE = 'TICKET_READ_ONLY';

/**
 * @param {unknown} raw — typically `HttpClientError` / axios-style rejection from the web API layer
 * @returns {{ message: string, code?: string, status?: number }}
 */
export function parseTicketHttpError(raw) {
    if (raw && typeof raw === 'object' && raw.name === 'ApiError' && typeof raw.message === 'string') {
        return {
            message: raw.message,
            code: typeof raw.code === 'string' ? raw.code : undefined,
            status: typeof raw.statusCode === 'number' ? raw.statusCode : undefined,
        };
    }
    const axiosErr = raw?.originalError ?? raw;
    const data = axiosErr?.response?.data ?? raw?.response?.data;
    const status =
        axiosErr?.response?.status ?? raw?.response?.status ?? raw?.status ?? raw?.statusCode;
    const code = typeof data?.code === 'string' ? data.code : undefined;
    const message =
        (typeof data?.error === 'string' && data.error) ||
        (typeof data?.message === 'string' && data.message) ||
        (typeof raw?.message === 'string' ? raw.message : '') ||
        '';
    return { message, code, status };
}

/**
 * Toast copy for ticketing mutations — maps `TICKET_READ_ONLY` via i18n.
 * @param {unknown} error
 * @param {string} fallback
 */
export function ticketMutationToastMessage(error, fallback) {
    const { message, code } = parseTicketHttpError(error);
    if (code === TICKET_API_READ_ONLY_CODE) {
        return i18n.t('readOnly.operationBlockedToast', {
            ns: 'ticketingDetail',
            defaultValue: message || fallback,
        });
    }
    return getIntegrationErrorMessage({
        ...(error && typeof error === 'object' ? error : {}),
        message,
    }) || fallback;
}
